import { Button } from 'components/Base';
import React, { useState } from 'react';
import { timeHorizonEnum } from 'utils/timeHorizon';
import ForecaseReturnInputs from './ForecastReturnInputs';
import ForecastReturnRow from './ForecastReturnRow';

type ForecastReturnsTableProps = {
  riskLevelDescriptions: any[];
  timeHorizon?: string;
  returnAndRisk: {};
  defaultRiskAndReturn: {};
  updateValues: Function;
  timeHorizonEnumVal?: timeHorizonEnum;
  saveTables: Function;
  isSaving: boolean;
  isFirmAdmin: boolean;
  isCustom: boolean;
  hasRisk?: boolean;
  displayRiskLevel?: boolean;
};

const ForecastReturnsTable: React.FC<ForecastReturnsTableProps> = ({
  riskLevelDescriptions,
  timeHorizon = null,
  returnAndRisk,
  defaultRiskAndReturn,
  updateValues,
  timeHorizonEnumVal = null,
  saveTables,
  isSaving,
  isFirmAdmin,
  isCustom,
  hasRisk = true,
  displayRiskLevel = true
}) => {
  const [isTableVisible, setIsTableVisible] = useState(false);

  return (
    <div>
      {timeHorizon && <h4 style={{ marginLeft: '16px' }}>{timeHorizon}</h4>}
      <div style={{ marginTop: '32px', marginBottom: '32px' }}>
        <div className="forecastReturnsConfigContainer">
          <div
            className="riskLevelInput"
            style={{
              width: `calc(100% / ${riskLevelDescriptions.length + 1})`,
              fontWeight: 'bold'
            }}
          >
            <div></div>
          </div>
          {riskLevelDescriptions.map((rld: any) => {
            return (
              <div
                key={`${rld.risk_type}`}
                className="riskLevelInput"
                style={{
                  width: `calc(100% / ${riskLevelDescriptions.length + 1})`,
                  fontWeight: 'bold'
                }}
              >
                {displayRiskLevel ? (
                  <div>{`${rld.risk_level}. ${rld.risk_type}`}</div>
                ) : (
                  <div>{rld.risk_type}</div>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: '32px', marginBottom: '32px' }}>
          <ForecaseReturnInputs
            riskLevelDescriptions={riskLevelDescriptions}
            title="Return"
            initValues={returnAndRisk}
            defaultRiskAndReturn={defaultRiskAndReturn}
            onChange={updateValues}
            timeHorizonEnumVal={timeHorizonEnumVal}
            isFirmAdmin={isFirmAdmin}
            isCustom={isCustom}
          />
          {hasRisk && (
            <ForecaseReturnInputs
              riskLevelDescriptions={riskLevelDescriptions}
              title="Risk"
              initValues={returnAndRisk}
              defaultRiskAndReturn={defaultRiskAndReturn}
              onChange={updateValues}
              timeHorizonEnumVal={timeHorizonEnumVal}
              isFirmAdmin={isFirmAdmin}
              isCustom={isCustom}
            />
          )}
        </div>
        <div className="tableButtons">
          {hasRisk && (
            <Button
              type="submit"
              onClick={() => setIsTableVisible(!isTableVisible)}
              style={{ marginRight: '16px' }}
            >
              {`${isTableVisible ? 'Hide' : 'See'} Table`}
            </Button>
          )}
          {isFirmAdmin && isCustom && (
            <Button
              isLoading={isSaving}
              type="submit"
              onClick={() => saveTables()}
            >
              Save
            </Button>
          )}
        </div>
        <div
          style={{
            height: isTableVisible ? 'max-content' : 0,
            overflow: 'hidden'
          }}
        >
          <ForecastReturnRow
            riskLevelDescriptions={riskLevelDescriptions}
            title="In a very good year"
            returnAndRisk={returnAndRisk}
            defaultRiskAndReturn={defaultRiskAndReturn}
          />
          <ForecastReturnRow
            riskLevelDescriptions={riskLevelDescriptions}
            title="In a good year"
            returnAndRisk={returnAndRisk}
            defaultRiskAndReturn={defaultRiskAndReturn}
          />
          <ForecastReturnRow
            riskLevelDescriptions={riskLevelDescriptions}
            title="On average"
            returnAndRisk={returnAndRisk}
            defaultRiskAndReturn={defaultRiskAndReturn}
          />
          <ForecastReturnRow
            riskLevelDescriptions={riskLevelDescriptions}
            title="In a bad year"
            returnAndRisk={returnAndRisk}
            defaultRiskAndReturn={defaultRiskAndReturn}
          />
          <ForecastReturnRow
            riskLevelDescriptions={riskLevelDescriptions}
            title="In a very bad year"
            returnAndRisk={returnAndRisk}
            defaultRiskAndReturn={defaultRiskAndReturn}
          />
        </div>
      </div>
    </div>
  );
};

export default ForecastReturnsTable;
